/**
 * The quiet "show more" trigger (spec 232 FR-011): muted text with a chevron that
 * turns when the panel opens, a 44 px reach on coarse pointers (`touch-target`, never
 * a `min-h-*`, which would beat it) and the app's focus ring. Used by Token details,
 * the incompleteness Details and Used by's Show all, so the three read as one control.
 */
export const DISCLOSURE_TRIGGER =
  'text-muted-foreground hover:text-foreground focus-visible:ring-ring group touch-target inline-flex items-center gap-1 self-start rounded-sm text-xs font-medium focus-visible:ring-3 focus-visible:outline-none';

/** The chevron inside it; turns with the existing base motion token. */
export const DISCLOSURE_CHEVRON =
  'size-3.5 shrink-0 transition-transform duration-[var(--motion-duration-base)] group-data-[panel-open]:rotate-90 group-aria-expanded:rotate-90';
